/* Copyright (c) 2026 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useMemo } from "react";
import { PlanSortFields, SortOrder } from "~/generated/graphql";
import { createValueLabelMap } from "~/hooks/useAppliedFilters/utils";
import { useGetAllActions } from "~/hooks/useGetAllActions";
import { useGetPlans } from "~/views/plans/hooks";
import { getEventActionLabel } from "../components/eventActionLabels";
import { createEventsAppliedFilters } from "../components/eventsAppliedFilters";

export function useEventsAppliedFilters() {
  const { customActions, systemActions } = useGetAllActions();
  const { data: plans } = useGetPlans({
    page: "1",
    limit: "1000",
    sort: {
      field: PlanSortFields.Name,
      order: SortOrder.Asc,
    },
  });

  const eventActionNamesById = useMemo(
    () =>
      createValueLabelMap(
        [...systemActions, ...customActions],
        (action) => action.id,
        (action) => getEventActionLabel(action.name)
      ),
    [customActions, systemActions]
  );

  const eventRelatedPlanNamesById = useMemo(
    () =>
      createValueLabelMap(
        plans,
        (plan) => plan.id,
        (plan) => plan.name
      ),
    [plans]
  );

  return useMemo(
    () =>
      createEventsAppliedFilters(
        eventActionNamesById,
        eventRelatedPlanNamesById
      ),
    [eventActionNamesById, eventRelatedPlanNamesById]
  );
}
